import Reflux from "reflux";

export default Reflux.createActions([
  "selectFavoriteGenre",
  "deselectFavoriteGenre",
  "submitSelectedGenres",
]);
